import {type ReactNode, useRef, createContext} from "react";
import {useLocation} from "react-router-dom";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Form from "../Form/Form";
// Импортируем новый компонент (путь может отличаться в зависимости от твоей структуры папок)
import ReviewForm from "../ReviewForm/ReviewForm";

import "./Layout.scss";

interface Props {
    children: ReactNode;
    hideForm?: boolean;
}

export const FormRefContext = createContext<React.MutableRefObject<HTMLDivElement | null> | null>(null);

const Layout = ({children, hideForm = false}: Props) => {
    const location = useLocation();
    const formRef = useRef<HTMLDivElement>(null);

    const isHomePage = location.pathname === "/";
    const isAdminPage = location.pathname === "/admin";
    const isAdminDashboard = location.pathname === "/admin/dashboard";
    const isNotFoundPage = location.pathname === "*";

    // Проверка: это страница отзывов?
    const isReviewsPage = location.pathname === "/reviews";

    // Добавляем !isReviewsPage, чтобы скрыть обычную форму контактов на этой странице
    const shouldShowForm = !isAdminPage && !isAdminDashboard && !isNotFoundPage && !hideForm && !isReviewsPage;

    // Показывать форму отзыва только на странице отзывов (если она не скрыта принудительно)
    const shouldShowReviewForm = isReviewsPage && !hideForm;

    const shouldShowFooter = !isAdminPage && !isAdminDashboard;

    return (
        <FormRefContext.Provider value={formRef}>
            <div className="layout">
                <Header scrollToFormRef={formRef}/>

                <main className={`main-content ${isHomePage ? "home-page" : ""}`}>
                    {children}
                </main>

                {/* Обычная форма обратной связи */}
                {shouldShowForm && <Form ref={formRef}/>}

                {/* Новая форма отзыва */}
                {shouldShowReviewForm && <ReviewForm />}

                {shouldShowFooter && <Footer/>}
            </div>
        </FormRefContext.Provider>
    );
};

export default Layout;
